import { useCallback, useEffect, useRef } from "react";

export function useScopedTimeout() {
  const timeoutsRef = useRef<number[]>([]);

  const runTimeout = useCallback((cb: () => void, delay: number) => {
    const id = window.setTimeout(() => {
      cb();
      timeoutsRef.current = timeoutsRef.current.filter((t) => t !== id);
    }, delay);

    timeoutsRef.current.push(id);
    return id;
  }, []);

  const clearTimeouts = useCallback((id?: number) => {
    if (typeof id === "number") {
      window.clearTimeout(id);
      timeoutsRef.current = timeoutsRef.current.filter((t) => t !== id);
    } else {
      timeoutsRef.current.forEach(window.clearTimeout);
      timeoutsRef.current = [];
    }
  }, []);

  useEffect(() => () => clearTimeouts(), [clearTimeouts]);

  return { runTimeout, clearTimeouts };
}
